import { j as m } from "../../../jsx-runtime-B6kdoens.js";
import { a as s } from "../../../index-CROKJrb5.js";
import { c as p, f } from "../../../create-component-CBAeEoQ6.js";
import { Typography as c } from "../../Typography/index.js";
const h = p(
  "ModalHeader",
  f(
    ({ children: r, className: o, size: a = "h1", ...e }, t) => /* @__PURE__ */ m.jsx(
      c,
      {
        ref: t,
        className: s("cur-grow", o),
        size: a,
        ...e,
        children: r
      }
    )
  )
);
export {
  h as ModalHeader
};
//# sourceMappingURL=index.js.map
